const formatPartialData = function(data) {
    let boData = data.branch_office_data[0]
    if (boData && boData.warranty_days) {
        data.warranty_days = boData.warranty_days
        delete data.branch_office_data.warranty_days
    }
    if (!boData.minimum_stock) data.branch_office_data[0].minimum_stock = 0
    if (data.minimum_stock) {
        data.branch_office_data[0].minimum_stock = data.minimum_stock
        delete data.minimum_stock
    }
    if (!boData.maximum_stock) data.branch_office_data[0].maximum_stock = 1
    if (data.maximum_stock) {
        data.branch_office_data[0].maximum_stock = data.maximum_stock
        delete data.maximum_stock
    }
    if (!boData.critical_stock) data.branch_office_data[0].critical_stock = 0
    if (data.critical_stock) {
        data.branch_office_data[0].critical_stock = data.critical_stock
        delete data.critical_stock
    }
    if (!boData.gains_margin) data.branch_office_data[0].gains_margin = 0
    if (!data.wh_unit_of_measurement_id) data.wh_unit_of_measurement_id = 1
    if (!data.uom_quantity) data.uom_quantity = 1
    let booleans = [
        'is_inventoriable',
        'have_decimal_quantity',
        'is_repackaged',
        'is_tax_free',
        'is_salable',
        'is_consumable',
        'is_seasonal',
    ]
    booleans.forEach(boolean => {
        if (data.branch_office_data[0][boolean]) {
            data[boolean] = data.branch_office_data[0][boolean]
            delete data.branch_office_data[0][boolean]
            return
        }
        if (!data[boolean]) data[boolean] = false
    })
    return data
}

const getFormatPartialData = function(scope) {
    return formatPartialData.bind(scope)
}

export default getFormatPartialData
